import { render, staticRenderFns } from "./CmgLargeOrderPromo.vue?vue&type=template&id=132121b2&scoped=true&lang=pug&"
import script from "./cmg-large-order-promo.ts?vue&type=script&lang=ts&"
export * from "./cmg-large-order-promo.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLargeOrderPromo.vue?vue&type=style&index=0&id=132121b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132121b2",
  null
  
)

export default component.exports